import { useEffect } from 'react';

import { ArticleDetailsContent } from '@/components/ArticleDetailsContent';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { track } from '@/lib/mixpanel';
import { NewsArticle } from '@/schema';

interface NewsDetailsModalProps {
  article: NewsArticle;
  isOpen: boolean;
  onClose: () => void;
}

export function NewsDetailsModal({
  article,
  isOpen,
  onClose,
}: NewsDetailsModalProps) {
  useEffect(() => {
    if (isOpen) {
      track('NewsModal_Opened', { articleId: article.id, articleTitle: article.title });
    }
  }, [isOpen, article.id, article.title]);

  const handleClose = () => {
    track('NewsModal_Closed', { articleId: article.id });
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && handleClose()}>
      <DialogContent className="max-h-[90vh] w-[95vw] max-w-md overflow-y-auto border-2 border-neutral-200 bg-white p-4 shadow-xl sm:p-8 md:max-w-3xl">
        <ArticleDetailsContent article={article} isActive={isOpen} />
      </DialogContent>
    </Dialog>
  );
}
